/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style utility container so all utility related
 * stuff has a centralized wrapper.
 */
var iaw = iaw || { };

iaw.profile = {

	/**
	 * Configuration
	 */
	configurations: {
		stage: {
			url:	'https://cc-collab-stage.adobe.io/profile',
			expirationDays: 1
		},
		prod: {
			url:	'https://cc-collab.adobe.io/profile',
			expirationDays: 1
		}
	},
	config: null,
	retryAttempt: 	0,

	/**
	 * Fetch profile image.
	 * @param userGUID     user GUID
	 * @param token        access token
	 */
	fetchImage: function(userGUID, token, callback) {
		var self = this;
		var url;

		iaw.util.promise('GET', self.config.url, token)
		.then(function(response) {
			switch (typeof response) {
				case 'string':
					url = JSON.parse(response).user.avatar;
					break;
				case 'object':
					url = response.user.avatar;
					break;
			}
			if (!url) return callback(null);
			iaw.util.downLoadImage( url, function(blob) {
				if (!blob) {
					if (self.callback) {
						self.callback( null );
					}
					return;
				}
				var reader = new window.FileReader();

				reader.readAsDataURL( blob );
				reader.onloadend = function() {
					var imageBase64 = reader.result;

					iaw.localstorage.setUserItem('profile_image', imageBase64 );
					iaw.localstorage.setUserItem('profile_image_timestamp', new Date().getTime() );
					iaw.log.debug( '[' + url + '] Downloaded profile image for user [' + userGUID + ']' );
					callback(imageBase64);
				};
			});
			self.retryAttempt = 0;
		})
		.catch(function(err) {
			iaw.log.debug( 'Fail to download profile image with retryAttempt=' + self.retryAttempt);
			if (self.retryAttempt  === 0) {
				// access token is expired. Clear access token and retry once.
				iaw.cepUtil.clearAccessToken();
				self.getProfilePicture( userGUID, callback, ++self.retryAttempt );
			}
		});
	},

	/**
	 * Check to see if we have a profile picture and make sure
	 * it is not expired.
	 *
	 * @param userGUID     user GUID
	 * @return true if available from cache, false otherwise
	 */
	isProfilePictureAvailable: function( userGUID ) {

		var isAvailable = false;

		// make sure we have the configuration setup - if not
		// set the default to the production configuration
		var expirationDays =  this.config.expirationDays;

		// fetch image from local storage if it was cached within expirationDays
		var imageBase64 = iaw.localstorage.getUserItem('profile_image');
		var timestamp   = iaw.localstorage.getUserItem('profile_image_timestamp');

		if ( imageBase64 && timestamp ) {
			var days = ( new Date().getTime() - timestamp ) / ( 24 * 3600 * 1000 );

			isAvailable = ( timestamp && days < expirationDays );
		}
		return isAvailable;
	},

	/**
	 * Public API
	 */

	/**
	 * Get Profile picture.
	 *
	 * @param userGUID     user GUID
	 * @param callback     completion callback method
	 * @param retryAttempt retry times once token is expired
	 */
	getProfilePicture: function( userGUID, callback, retryAttempt ) {
		this.retryAttempt = retryAttempt || 0;
		this.config = this.config || (iaw.cepUtil.usingStageAuthentication() ? this.configurations.stage : this.configurations.prod);

		iaw.log.debug('Start to get profile Picture, for user [' + userGUID + ']');

		// check to see if we already have one cached
		if ( this.isProfilePictureAvailable( userGUID ) ) {
			iaw.log.debug( 'Found cached profile image for user [' + userGUID + ']');
			var imageBase64 = iaw.localstorage.getUserItem('profile_image');
			if ( callback ) { callback( imageBase64 ); }
			return;

		}

		// no cached profile image available, then access profile api to get a new one
		iaw.cepUtil.getIMSAccessToken( function( token ) {
			iaw.profile.fetchImage( userGUID, token, callback );
		});
	}
};
